"use client";

import { Flex } from "@chakra-ui/react";
import { PolicyLayout } from "../../_components/PolicyLayout";
import { useTranslations } from "next-intl";
import {
  IoCheckmarkDone,
  IoReader,
  IoPersonCircle,
  IoCard,
  IoServer,
  IoPeopleCircle,
  IoRibbon,
  IoBan,
  IoWarning,
  IoPower,
  IoScale,
  IoRefresh,
  IoMail,
} from "react-icons/io5";
import { HELP_CENTER_IDS } from "../../_constants/help-center.ids";
import {
  PolicyIntroCard,
  PolicyList,
  PolicySectionCard,
  PolicyText,
} from "../../_components/policy/PolicyContentPrimitives";

export function TermsOfServiceContent() {
  const t = useTranslations("landing.policies");

  return (
    <PolicyLayout
      title={t("terms.title")}
      lastUpdated={t("terms.last_updated")}
    >
      <PolicyIntroCard id={HELP_CENTER_IDS.terms.intro}>
        {t("terms.intro")}
      </PolicyIntroCard>

      <Flex id={HELP_CENTER_IDS.terms.sections} direction="column" gap={3}>
        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(1)}
          icon={IoCheckmarkDone}
          number={1}
          sectionTitle={t("terms.acceptance.heading")}
        >
          <PolicyText>{t("terms.acceptance.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(2)}
          icon={IoReader}
          number={2}
          sectionTitle={t("terms.description.heading")}
        >
          <PolicyText>{t("terms.description.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.description.item1"),
              t("terms.description.item2"),
              t("terms.description.item3"),
              t("terms.description.item4"),
              t("terms.description.item5"),
              t("terms.description.item6"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(3)}
          icon={IoPersonCircle}
          number={3}
          sectionTitle={t("terms.accounts.heading")}
        >
          <PolicyText>{t("terms.accounts.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.accounts.item1"),
              t("terms.accounts.item2"),
              t("terms.accounts.item3"),
              t("terms.accounts.item4"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(4)}
          icon={IoCard}
          number={4}
          sectionTitle={t("terms.subscription.heading")}
        >
          <PolicyText>{t("terms.subscription.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.subscription.item1"),
              t("terms.subscription.item2"),
              t("terms.subscription.item3"),
              t("terms.subscription.item4"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(5)}
          icon={IoServer}
          number={5}
          sectionTitle={t("terms.data_usage.heading")}
        >
          <PolicyText>{t("terms.data_usage.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.data_usage.item1"),
              t("terms.data_usage.item2"),
              t("terms.data_usage.item3"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(6)}
          icon={IoPeopleCircle}
          number={6}
          sectionTitle={t("terms.community.heading")}
        >
          <PolicyText>{t("terms.community.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.community.item1"),
              t("terms.community.item2"),
              t("terms.community.item3"),
              t("terms.community.item4"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(7)}
          icon={IoRibbon}
          number={7}
          sectionTitle={t("terms.ip.heading")}
        >
          <PolicyText>{t("terms.ip.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(8)}
          icon={IoBan}
          number={8}
          sectionTitle={t("terms.prohibited.heading")}
        >
          <PolicyText>{t("terms.prohibited.content")}</PolicyText>
          <PolicyList
            items={[
              t("terms.prohibited.item1"),
              t("terms.prohibited.item2"),
              t("terms.prohibited.item3"),
              t("terms.prohibited.item4"),
              t("terms.prohibited.item5"),
            ]}
          />
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(9)}
          icon={IoWarning}
          number={9}
          sectionTitle={t("terms.limitation.heading")}
        >
          <PolicyText>{t("terms.limitation.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(10)}
          icon={IoPower}
          number={10}
          sectionTitle={t("terms.termination.heading")}
        >
          <PolicyText>{t("terms.termination.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(11)}
          icon={IoScale}
          number={11}
          sectionTitle={t("terms.governing_law.heading")}
        >
          <PolicyText>{t("terms.governing_law.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(12)}
          icon={IoRefresh}
          number={12}
          sectionTitle={t("terms.changes.heading")}
        >
          <PolicyText>{t("terms.changes.content")}</PolicyText>
        </PolicySectionCard>

        <PolicySectionCard
          sectionId={HELP_CENTER_IDS.terms.section(13)}
          icon={IoMail}
          number={13}
          sectionTitle={t("terms.contact.heading")}
        >
          <PolicyText>{t("terms.contact.content")}</PolicyText>
        </PolicySectionCard>
      </Flex>
    </PolicyLayout>
  );
}
